import * as S from "./commonStyles";

import { useReport } from "contexts/ReportContext";

export function CommentsTab() {
  const { report } = useReport();

  return (
    <S.Container>
      <S.Row>
        <S.CommentsSection>
          {report?.occurrence?.comments &&
          report?.occurrence?.comments?.length > 0 ? (
            report?.occurrence?.comments?.map((comment) => (
              <span className="comments-container" key={comment.id}>
                <div>
                  <h3 className="autor">{comment.attendant?.name}</h3>
                  <h4 className="date">
                    {new Date(comment.createdAt).toLocaleDateString("pt-BR", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </h4>
                </div>
                <p className="content">{comment.content}</p>
              </span>
            ))
          ) : (
            <h4>Ainda sem comentários...</h4>
          )}
        </S.CommentsSection>
      </S.Row>
    </S.Container>
  );
}
